/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Deactivate_HintInputs */



/**
* | output |
* | --- |
* | "Pause this space to stop connector syncs and hide it from members. Files and embeddings are preserved and can be restored at any time." |
*
* @param {Spaces_Deactivate_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_deactivate_hint = /** @type {((inputs?: Spaces_Deactivate_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Deactivate_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pausiere diesen Space, um Connector-Syncs zu stoppen und ihn vor Mitgliedern zu verbergen. Dateien und Embeddings bleiben erhalten und können jederzeit wiederhergestellt werden.")
	return /** @type {LocalizedString} */ ("Pause this space to stop connector syncs and hide it from members. Files and embeddings are preserved and can be restored at any time.")
});